import React from 'react';
import { getSidebarTabId } from './SidebarTabs';

type SidebarTabPanelProps = Readonly<{
  activeTabId: string;
  children?: React.ReactNode;
  className?: string;
  panelId: string;
}>;

/**
 * Panel asociado a SidebarTabs. Cierra la referencia bidireccional del patrón
 * ARIA tabs: expone `role="tabpanel"`, su propio `id` (al que apunta el
 * `aria-controls` de cada tab) y `aria-labelledby` hacia el tab activo vía
 * `getSidebarTabId`. Encapsula la convención de ids para que el consumidor no
 * la reconstruya a mano — mismo patrón que `AccordionPanel`.
 *
 * `tabIndex` se omite a propósito: APG solo lo recomienda cuando el panel no
 * tiene contenido enfocable. Si un consumidor renderiza un panel sin foco
 * interno, debe añadir `tabIndex={0}` en el contenedor de contenido.
 */
function SidebarTabPanel({ activeTabId, children, className, panelId }: SidebarTabPanelProps): JSX.Element {
  return (
    <div aria-labelledby={getSidebarTabId(activeTabId)} className={className} id={panelId} role="tabpanel">
      {children}
    </div>
  );
}

export default SidebarTabPanel;
